import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { usePermissions } from "../Context/PermissionContext.tsx";
import { PERMISSION_FEATURES, PERMISSION_ACTIONS } from "../Constants/Permissions.ts";

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { hasPermission, loading, permissionData, error } = usePermissions();

  // On a hard refresh, `loading` starts false and only flips true once the
  // access token resolves and the permissions fetch actually kicks off — so
  // relying on `loading` alone lets this guard evaluate (and redirect) during
  // that initial gap, before permissions have had a chance to load. Wait
  // until we actually have a result (data or a definitive error) instead.
  if (loading || (!permissionData && !error)) {
    return (
      <div className="flex justify-content-center align-items-center" style={{ height: "60vh" }}>
        <ProgressSpinner style={{ width: "40px", height: "40px" }} />
      </div>
    );
  }

  const canAccessAdmin = hasPermission(PERMISSION_FEATURES.ADMIN, PERMISSION_ACTIONS.EDIT) === true;

  if (!canAccessAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
